<template>
  <div class=" placings-table">
    <table>
      <thead class="headers">
      <tr>
        <th>MA</th>
        <th>DI</th>
        <th>WO</th>
        <th>DO</th>
        <th>VR</th>
        <th><span class="total-header">TOTAAL</span></th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>{{placementsAdded.week[0]}}</td>
        <td>{{placementsAdded.week[1]}}</td>
        <td>{{placementsAdded.week[2]}}</td>
        <td>{{placementsAdded.week[3]}}</td>
        <td>{{placementsAdded.week[4]}}</td>
        <td><span class="total-placed">{{totalPlacements.added}}</span></td>
      </tr>
      <tr class="total-lost-row">
        <td>{{placementsDeleted.week[0]}}</td>
        <td>{{placementsDeleted.week[1]}}</td>
        <td>{{placementsDeleted.week[2]}}</td>
        <td>{{placementsDeleted.week[3]}}</td>
        <td>{{placementsDeleted.week[4]}}</td>
        <td><span class="total-lost">{{totalPlacements.lost}}</span></td>
      </tr>
      <tr class="total-week-row">
        <td>{{placementsAdded.week[0] + placementsDeleted.week[0]}}</td>
        <td>{{placementsAdded.week[1] + placementsDeleted.week[1]}}</td>
        <td>{{placementsAdded.week[2] + placementsDeleted.week[2]}}</td>
        <td>{{placementsAdded.week[3] + placementsDeleted.week[3]}}</td>
        <td>{{placementsAdded.week[4] + placementsDeleted.week[4]}}</td>
        <td style="background-color: #25b7bc"><span class="total-week">{{totalPlacements.total}}</span></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'weekly-placings-table',
    props: ['placementsAdded','placementsDeleted','totalPlacements'],
    methods: {

    },
    computed: {

    }

  }
</script>

<style lang="scss" scoped>

  .left-side {

    table {
      background-color: white;
      table-layout: fixed;
      width: 100%;
      height:800px;

    }

    td, th {
      text-align: center;
    }

    th {
      font-size: 60px;
      color: #505050;
      line-height: 150px;
    }

    td {
      border: 1px solid lightgray;
      font-size: 90px;
      width: 100%;
      color: #606060;
      font-weight: bolder;
      line-height: 95px;
    }
  }

  .total-header {
    color: #25b7bc;

  }

  .total-lost-row {
    background-color: #F0F0F0;

    td {
      color: #606060 !important;
    }

  }

  .total-placed, .total-lost {
    color: #606060;
  }

  .total-week {
    color: #ffffff;
  }

  .placings-table {
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
  }

</style>